// Impersonation banner height management
// This module handles dynamic height calculation and applies it to sidebar elements

// Apply banner offset to all sidebar-related elements
function applyBannerOffset(height: number): void {
  const heightPx = height + 'px';
  const calcHeight = `calc(100vh - ${heightPx})`;

  // Target mobile sidebar sheet content
  const selectors = [
    '[data-sidebar="sidebar"][data-mobile="true"]',
    '[data-slot="sidebar"][data-mobile="true"]',
    '[data-slot="sheet-content"][data-mobile="true"]',
    '[data-slot="sheet-overlay"]'
  ];

  selectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
      if (el instanceof HTMLElement) {
        el.style.top = heightPx;
        el.style.height = calcHeight;
        el.style.maxHeight = calcHeight;
      }
    });
  });
}

// Update banner height dynamically
function updateBannerHeight(): void {
  const banner = document.getElementById('impersonation-banner');
  if (banner) {
    const height = banner.offsetHeight;
    document.documentElement.style.setProperty('--impersonation-banner-height', height + 'px');

    // Also apply styles directly to mobile sidebar elements for better compatibility
    applyBannerOffset(height);
  }
}

// Initialize impersonation banner behavior
export function initializeImpersonationBanner(): void {
  // Only run if banner exists
  const banner = document.getElementById('impersonation-banner');
  if (!banner) return;

  // Update on load and resize
  updateBannerHeight();
  window.addEventListener('resize', updateBannerHeight);

  // Update after fonts load (can affect height)
  if (document.fonts) {
    document.fonts.ready.then(updateBannerHeight);
  }

  // Watch for DOM changes (when sidebar is opened)
  const observer = new MutationObserver(() => {
    const banner = document.getElementById('impersonation-banner');
    if (banner) {
      applyBannerOffset(banner.offsetHeight);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
